export const ARTICLE_SIDE_INDENT = '5%';
